import styled from 'styled-components/macro';

import {Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Select} from "@chakra-ui/react";
import {useState} from "react";
import {useCreateCryptoPayment, useSubscriptionRenewal} from "../../api/payments";
import {useFeedback} from "../../store/feedback";
import {themecolors} from "../../utils/themecolors";

const Description = styled.div``;
const Quantity = styled.div``;
const Heading = styled.div``;
const Total = styled.div``;
const TotalHeading = styled.span``;
const PaymentMethod = styled.div``;
const PaymentTitle = styled.h2``;
const PaymentDescription = styled.div``;
const PaymentText = styled.div``;
const CryptoHeading = styled.div``;
const CryptoAddress = styled.div``;
const MakePayment = styled.div``;
const AwaitingPayment = styled.div``;

const coinMap = {
    "Bitcoin": "btc",
    "Ethereum": "eth",
    "Dogecoin": "doge",
    "Litecoin": "ltc",
    "Tether": "usdt",
    "USD Coin": "usdc",
    "Bitcoin Cash": "bch"
};

const PayWithCrypto = styled(({className, type, tier = 0, length = 0, awards = 0, renew, subscriptionPrice, onClose}) => {
    const [cryptocurrency, setCryptocurrency] = useState("");
    const {error, feedbackCh} = useFeedback();
    const cryptoPayment = renew ? useSubscriptionRenewal(feedbackCh) :
        useCreateCryptoPayment(feedbackCh, type, tier, length, awards, subscriptionPrice);
    const id = cryptoPayment?.id;
    const formattedCoin = cryptocurrency.replaceAll(" ", "").toLowerCase();
    return (
        <Modal
            isOpen
            onClose={onClose}
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Send Payment</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6} className={className}>

                    {cryptocurrency === '' ?
                            <>
                                <MakePayment>Make a payment with cryptocurrency.</MakePayment>
                                <Select placeholder='Select cryptocurrency'
                                        onChange={(e) => setCryptocurrency(e.currentTarget.value)}>
                                    <option value='Bitcoin'>Bitcoin (BTC)</option>
                                    <option value='Ethereum'>Ethereum (ETH)</option>
                                    <option value='Dogecoin'>Dogecoin (DOGE)</option>
                                    <option value='Litecoin'>Litecoin (LTC)</option>
                                    <option value='Tether'>Tether (USDT)</option>
                                    <option value='USD Coin'>USD Coin (USDC)</option>
                                    <option value='Bitcoin Cash'>Bitcoin Cash (BCH)</option>
                                </Select>
                            </>
                        :
                            <>
                                <p>Please send your payment promptly to avoid delays.</p>
                                <p style={{fontWeight: 500, fontSize: 15, marginTop: 16}}>{coinMap[cryptocurrency].toUpperCase()} Address</p>
                                <p>{cryptoPayment?.cryptocurrencies[formattedCoin].address}</p>
                                <p style={{fontWeight: 500, fontSize: 15, marginTop: 12}}>Total Amount</p>
                                <p>{cryptoPayment?.cryptocurrencies[formattedCoin].price} {coinMap[cryptocurrency].toUpperCase()} + network fees</p>
                                <p style={{fontWeight: 500, fontSize: 15, marginTop: 12}}>Payment Status</p>
                                <p>Checking for payment...</p>
                                <p style={{fontSize: 14, marginTop: 24}}>You can safely close this window at any time.</p>
                            </>
                        }

                </ModalBody>
            </ModalContent>
        </Modal>
    )})`
    ${Description} {
      margin-bottom: 6px;
    }
  ${Quantity} {
    padding-top: 2px;
    font-size: 15px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }
  ${Heading} {
    margin-top: 16px;
    font-weight: 500;
    font-size: 16px;
  }
  ${Total} {
    margin-top: 16px;
    font-size: 16px;
  }
  ${TotalHeading} {
    font-weight: 500;
    font-size: 18px;
    padding-right: 8px;
  }
  ${PaymentMethod} {
    border: 1px solid ${({theme}) => theme.color.name === 'dark' ? '#343536' : '#f2f2f2'};
    border-radius: 4px;
    padding: 16px;
    margin-bottom: 8px;
    display: flex;
    cursor: pointer;
  }
  ${PaymentText} {
    padding-left: 16px;
  }
  ${PaymentDescription} {
    font-size: 14px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }
  ${PaymentTitle} {
    margin: 0 !important;
  }
  ${CryptoHeading} {
    font-size: 20px;
    font-weight: 500;
    text-align: center;
  }
  ${CryptoAddress} {
    font-size: 17px;
    font-weight: 500;
    text-align: center;
    margin-bottom: 8px;
  }
  ${MakePayment} {
    font-weight: 500;
    font-size: 16px;
    margin-bottom: 4px;
  }
  ${AwaitingPayment} {
    font-size: 15px;
    display: flex;
    align-items: center;
  }
`;

export default PayWithCrypto;